import { initializeApp } from "firebase/app";
import { getAuth,createUserWithEmailAndPassword,signInWithEmailAndPassword,sendPasswordResetEmail } from "firebase/auth";
import { getDatabase, ref, set } from "firebase/database";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBvcqJeCrLvQRirVCEtC7591mh0JfFd6Mo",
  authDomain: "ecomlevate.firebaseapp.com",
  databaseURL: "https://ecomlevate-default-rtdb.firebaseio.com",
  projectId: "ecomlevate",
  storageBucket: "ecomlevate.appspot.com",
  messagingSenderId: "348195231256",
  appId: "1:348195231256:web:81ebe77672caa1b89bd56d",
  measurementId: "G-DLRMMQ8DFG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app); // Initialize Firebase Storage instance

export { ref, set, auth, database, storage, app, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail };
